$(document).ready(function() {

 var isProductPage = window.priceTier.product;
 console.log("isProductPage from toric", isProductPage)
  
if(isProductPage != null){
  var productType = window.priceTier.product.type;
  var tags = window.priceTier.product.tags;
  
  if (productType == "Toric Contact Lenses" || productType == "Contact Lenses"){
    $('body').on('click', '[name="add"]', function() {
      var inputChk = document.getElementById('this-item-only-available-for-pre-order-and-requires-45-60-days-production-time');
      var inputweekChk = document.getElementById('this-item-only-available-for-pre-order-and-requires-1-2-weeks-production-time');
      if(inputChk != null){
      if(!inputChk.checked){
        $('#labelPreOrderItem').addClass('shake-text');
        setTimeout(function() {
          $('#labelPreOrderItem').removeClass('shake-text');
        }, 2000);
      }
      
      }else if(inputweekChk != null){
   if(!inputweekChk.checked){
        $('#labelPreOrderItem').addClass('shake-text');
        setTimeout(function() {
          $('#labelPreOrderItem').removeClass('shake-text');
        }, 2000);
      }
        
      }
      
    });
  }

  

  }
})